import { NOTIFICATION_POLL_INTERVAL } from './constants';

export const isWithinPollInterval = (dateTime) => {
  if (!dateTime) return false;
  const differenceInMilliseconds = new Date() - new Date(dateTime);

  //Ensure that the poll interval and the notification time range are aligned to prevent repeated notifications.
  // Only return true if the date is in the past (positive difference) and within the poll interval
  return differenceInMilliseconds >= 0 && differenceInMilliseconds <= NOTIFICATION_POLL_INTERVAL;
};
